"use client";

import type { FC, PropsWithChildren } from "react";
import { createContext, useContext } from "react";

const LoyaltyWrapperContext = createContext(false);

export const LoyaltyWrapperProvider: FC<PropsWithChildren> = ({ children }) => (
  <LoyaltyWrapperContext.Provider value={true}>{children}</LoyaltyWrapperContext.Provider>
);

export const useLoyaltyWrapperContext = () => useContext(LoyaltyWrapperContext);
